/**
 * Tells the other tabs a sign-out or a sign-in happened, so none of them keeps
 * showing the last person's data (or writing it back to the shared localStorage
 * cache): a sign-out sends them to /login, a sign-in makes them ask who is
 * signed in now.
 */

const CHANNEL = 'warike-auth'
const SIGNED_OUT = 'signed-out'
const SIGNED_IN = 'signed-in'

export function announceSignOut(): void {
  if (typeof BroadcastChannel === 'undefined') return
  const channel = new BroadcastChannel(CHANNEL)
  channel.postMessage({ type: SIGNED_OUT })
  channel.close()
}

/** Calls `onSignOut` when another tab signs out. Returns the unsubscribe. */
export function listenForSignOut(onSignOut: () => void): () => void {
  if (typeof BroadcastChannel === 'undefined') return () => {}
  const channel = new BroadcastChannel(CHANNEL)
  channel.onmessage = (event: MessageEvent<{ type?: string }>) => {
    if (event.data?.type === SIGNED_OUT) onSignOut()
  }
  return () => channel.close()
}

/** Tells the other tabs `userId` is now signed in here. */
export function announceSignIn(userId: string): void {
  if (typeof BroadcastChannel === 'undefined') return
  const channel = new BroadcastChannel(CHANNEL)
  channel.postMessage({ type: SIGNED_IN, userId })
  channel.close()
}

/** Calls `onSignIn` with the user's id when another tab signs in. Returns the unsubscribe. */
export function listenForSignIn(onSignIn: (userId: string) => void): () => void {
  if (typeof BroadcastChannel === 'undefined') return () => {}
  const channel = new BroadcastChannel(CHANNEL)
  channel.onmessage = (event: MessageEvent<{ type?: string; userId?: string }>) => {
    if (event.data?.type === SIGNED_IN && typeof event.data.userId === 'string') {
      onSignIn(event.data.userId)
    }
  }
  return () => channel.close()
}
